module.exports = __webpack_public_path__ + "img/countdownPopup.17fc3b94.png";